<template>
  <b-form>
    <b-form-row>
      <b-form-group class="col-sm-12">
        <label for="componente">Componente  <span style="color: red">(*)</span></label>
        <b-form-input
          type="text"
          name="componente"
          v-model="selectedCarcinogenicidad.componente"
          required
        >
        </b-form-input>
      </b-form-group>
    </b-form-row>
    <b-form-row>
      <b-form-group class="col-sm-12">
        <label for="id_grupo">Grupo</label>
        <el-select v-model="selectedCarcinogenicidad.id_grupo"
                   name="id_grupo"
                   placeholder=" "
                   size="small"
                   data-vv-as=" "
                   v-validate="{
                     rules: {
                       required: true
                     }
                   }"
        >
          <el-option v-for="item in iarc_grupos"
                     :key="item.id"
                     :label="item.lista"
                     :value="item.id"
          />
        </el-select>
      </b-form-group>
    </b-form-row>
  </b-form>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "ModalFormCarcinogenicidad",
  async created() {
    await this.getIarcGrupos();
  },
  methods: {
    ...mapActions('fds_productos',[
      'getIarcGrupos'
    ]),
  },
  computed: {
    ...mapState('fds_productos',[
      'selectedCarcinogenicidad',
      'iarc_grupos'
    ]),
  }
}
</script>

<style scoped>

</style>
